import client from './client';

export interface FlagDetail {
  key: string;
  enabled: boolean;
  description?: string | null;
  updated_at?: string | null;
}

export const featureFlagsAPI = {
  /** Public — returns { key: enabled } for every known flag. */
  async getPublicFlags(): Promise<Record<string, boolean>> {
    const { data } = await client.get<Record<string, boolean>>('/api/feature-flags');
    return data;
  },

  /** Admin — full row payload incl. description + updated_at. */
  async adminListFlags(): Promise<FlagDetail[]> {
    const { data } = await client.get<FlagDetail[]>('/api/admin/feature-flags');
    return data;
  },

  /** Admin — toggle a flag on/off. */
  async adminSetFlag(key: string, enabled: boolean): Promise<FlagDetail> {
    const { data } = await client.patch<FlagDetail>(
      `/api/admin/feature-flags/${encodeURIComponent(key)}`,
      { enabled },
    );
    return data;
  },
};

